import {createApp} from 'vue'
import App from './App.vue'
//引入Vue-router
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import vue3JsonExcel from "vue3-json-excel"



const app = createApp(App)
    app.use(ElementPlus)
    app.use(vue3JsonExcel)
    app.use(router).mount('#app')
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)}
